import React from 'react';
import { FinalReportButton } from './FinalReportButton';

interface Props {
  owner: any;
}

export const FinalReportLoader = (props: Props) => {
  const [show, setShow] = React.useState(false);

  return (
    <React.Fragment>
      {show || (
        <button type='button' className='btn btn-info' onClick={() => setShow(true)}>
          Generate Final Report
        </button>
      )}
      {show && <FinalReportButton owner={props.owner} />}
    </React.Fragment>
  );
};
